import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { getAllReviews } from "../redux/user/review/reviews_service_syn";
import LoaderScreen from "./loader/loaderScreen";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import testimonialImage from '../assets/img/new/Untitled-design-1.png'

const Testimonial = () => {
  const dispatch = useDispatch();
  const { testimonials, loading } = useSelector((state) => state.testimonials);


  useEffect(() => {
    dispatch(getAllReviews({ page: 1, limit: 10 }));
  }, [dispatch]);

  return (
    <section className="testimonial__section section--padding pt-0">
      <div className="container-fluid">
        <div className="row row-cols-xl-2 row-cols-1">
          <div className="col col-lg-order">
            <div className="testimonial__banner--thumbnail">
              <a className="display-block" href="/shop">
                <img
                  className="testimonial__banner--thumbnail__img display-block"
                  src={testimonialImage}
                  alt="banner-img"
                />
              </a>
            </div>
          </div>
          <div className="col">
            <div className="testimonial__section--inner">
              <div className="section__heading style2 border-bottom mb-50">
                <h2 className="section__heading--maintitle">Clients Testimonial</h2>
              </div>
              {loading ? (
                <LoaderScreen />
              ) : testimonials && testimonials.length > 0 ? (
                <Swiper
                  spaceBetween={30}
                  slidesPerView={1}
                  autoplay={{ delay: 5000 }}
                  navigation={true}
                  pagination={{ clickable: true }}
                  loop={testimonials.length > 1}
                  modules={[Pagination, Navigation, Autoplay]}
                  className="testimonial__swiper--activation testimonial__padding swiper mt-8"
                  centeredSlides={true}
                >
                  {testimonials.map((review) => (
                    <SwiperSlide key={review._id} className="swiper-slide flex justify-center items-center">
                      <div className="testimonial__items mx-auto max-w-md">
                        <div className="testimonial__items--topbar d-flex align-items-center justify-center">
                          <div className="testimonial__items--thumbnail">
                            <img
                              className="testimonial__items--thumbnail__img display-block"
                              src={review.pic_image}
                              alt={review.name}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "assets/img/other/user.png";
                              }}
                            />
                          </div>
                          <div className="testimonial__items--author">
                            <h3 className="testimonial__items--author__title h4">{review.name}</h3>
                            <h4 className="testimonial__items--author__subtitle h5">{review.adminName}</h4>
                          </div>
                        </div>
                        <div className="testimonial__items--content text-center">
                          <p className="testimonial__items--desc">
                            {review.review?.length > 60
                              ? review.review.slice(0, 60) + "..."
                              : review.review || "No review available."}
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

              ) : (
                <div className="text-center py-4">
                  <p>No testimonials available at the moment.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
